/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_IntroInputs */

const cs_billing_intro = /** @type {(inputs: Billing_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Každý si může dobít osobní peněženku. Admin plní firemní pool a alokuje ho makléřům. Osobní kredity se vždy čerpají první.`)
};

const en_billing_intro = /** @type {(inputs: Billing_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each person can top up a personal wallet. Admins fund the office pool and allocate it per broker. Personal credits are always spent first.`)
};

/**
* | output |
* | --- |
* | "Each person can top up a personal wallet. Admins fund the office pool and allocate it per broker. Personal credits are always spent first." |
*
* @param {Billing_IntroInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_intro = /** @type {((inputs?: Billing_IntroInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_IntroInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_intro(inputs)
	return cs_billing_intro(inputs)
});